export default __webpack_public_path__ + "static/media/gallery-24.b47e75ec.jpg";